import { isSet } from "../../../utils/commonUtils";

const RadioButton = (props) => {
  const {
    className,
    value,
    style,
    name,
    changeHandler,
    id,
    readOnly,
    disabled,
    options,
    labelStyle,
    appendClassLabel,
    optionLabelStyle,
    failedValue,  
  } = props;

  const onChangeHandler = (e, val) => {
    changeHandler(val); // Call the change handler with the selected value
  };
  
  return (
    <>
    {options.map((item, itemIndex) => {
      let appendStyles = {};
  
      if (
        isSet(failedValue, null) !== null &&
        failedValue.indexOf(isSet(item.value, item)) >= 0 &&
        failedValue.indexOf(value) === failedValue.indexOf(isSet(item.value, item))
      ) {
        appendStyles = { backgroundColor: 'red', borderColor: 'red' };
      }
  
      return (
        <div className={`${isSet(item.className, 'form-check form-check-inline d-inline-flex')} flex-shrink-0`} key={itemIndex}>
        <span><input
            className={className}
            type="radio"
            checked={value === isSet(item.value, item)}
            style={{
              ...style,
              ...appendStyles,
              ...(value === isSet(item.value, item) ? isSet(item.inputStyle, style) : {}),
            }}
            name={name}
            id={id + '_' + itemIndex}
            readOnly={readOnly}
            disabled={readOnly}
            onChange={(e) => onChangeHandler(e, isSet(item.value, item))}
          /></span>  

          <label
            className={`form-check-label-text text-nowrap ${isSet(item.appendClassLabel, isSet(appendClassLabel, 'font-weight-bold'))}    pl-1`}
            style={value === isSet(item.value, item) ? isSet(item.labelStyle, isSet(labelStyle, {})) : isSet(labelStyle, {})}
            htmlFor={id + '_' + itemIndex}
          >
            {isSet(item.label, item)}
          </label>
        </div>
      );
    })}
  </>
  );
};

RadioButton.defaultProps={
  className:'form-check-input',
  readOnly:false,
  disabled:false,
  failedValue:null,
  options:[] // Ensure options is always an array to prevent crash
}
export default RadioButton;